var cartModule = {
    options: {
    },
    init: function () {
        this.initJsCart();
        this.initCartDeleteBtns();
        this.initCartProceed();
        this.cartsListener();
        this.recalculatePriceMatrixCart();
    },
    initJsCart: function () {
        let cart = document.querySelector('#buyerData');

        if (cart) {
            cart = JSON.parse(cart.getAttribute('data-buyerData'));
            cartModule.renderCartTotals(cart);

            $('.online-checkbox-group > div input[type=checkbox]').on('change', function () {
                if ($(this)[0].hasAttribute('checked')) {
                    if ($('.online-checkbox-group > div input[checked]').length === 2) {
                        $(this).closest('label').removeClass('checked-label');
                        $(this).removeAttr('checked');
                    }
                } else {
                    $(this).closest('label').addClass('checked-label');
                    $(this).attr('checked', 'checked');
                }
            });
        }
    },

    initCartProceed: function () {
        $(document).on('change', '.payment-system-select', function () {
            let selectedValue = $(this).val();
            let payButton = $('.cart-proceed-form .pay-button');
            let ofertaAgreementTextCart = $('.oferta-agreement-text-cart');
            let feedbackFormWrap = $('.feedback-form__wrap');
            let isStripeActive = selectedValue === 'stripe';

            payButton.toggleClass('payment-proceed-stripe-btn', isStripeActive)
                .toggleClass('payment-proceed-btn', !isStripeActive);

            if (feedbackFormWrap.length) {
                if (isStripeActive) {
                    payButton.addClass('hidden');
                    ofertaAgreementTextCart.addClass('hidden-important');
                    feedbackFormWrap.removeClass('hidden');
                } else {
                    payButton.removeClass('hidden');
                    ofertaAgreementTextCart.removeClass('hidden-important');
                    feedbackFormWrap.addClass('hidden');
                }
            }

            if (selectedValue === 'platron') {
                document.querySelectorAll('.isStripe').forEach(function (element) {
                    element.value = 0;
                });
            } else {
                document.querySelectorAll('.isStripe').forEach(function (element) {
                    element.value = 1;
                });
                app.reCheckSticky();
            }
        });
    },
    initCartDeleteBtns: function () {
        var cartCfg = window.jsConfig.cart;
        if (typeof cartCfg != 'undefined' && cartCfg) {
            $(document).on('click', '.cart-item__actions .cart-item__delete-btn', function (e) {
                e.preventDefault();
                var $btn = $(this);
                var itemID = $btn.attr('data-itemid');
                var lectureID = $btn.attr('data-lectureId');
                var $cartItem = $btn.closest('.cart-item');
                var certificateCartDataId = $btn.attr('data-certificateCartDataId');

                var url = cartCfg.removeEndpoint;

                app.preventSpamClicks($btn, false);

                $.ajax({
                    url: url,
                    method: cartCfg.reqMethod,
                    dataType: 'json',
                    data: {
                        itemID: itemID,
                        lectureID: lectureID,
                        certificateCartDataId: certificateCartDataId,
                    },
                    success: function (response) {
                        $cartItem.fadeOut(600, function(){
                            $(this).remove();
                         });
                        var cart = response.cart;
                        if (cart.paymentUrl) {
                            cartModule.updatePaymentUrl(cart.paymentUrl);
                        } else {
                            cartModule.updatePaymentUrl(false);
                        }

                        cartModule.updateHeaderCart(cart.count);
                        cartModule.renderCartTotals(cart);
                        app.preventSpamClicks($btn, true);
                    }
                });
            });
        }
    },
    updateHeaderCart: function (cartItemsCount) {
        cartItemsCount = typeof cartItemsCount !== 'undefined' ? cartItemsCount : 0;
        let mainMenuUserCart = $('.main-navigation-menu__user-account--cart');

        mainMenuUserCart.toggleClass('main-navigation-menu__user-account--cart--hasItems', cartItemsCount > 0);

        if (cartItemsCount < 1) {
            mainMenuUserCart.hide('slow');
        } else {
            mainMenuUserCart.show('slow');
        }

        $('.header-cart-link__count').text(cartItemsCount);
    },
    updatePaymentUrl: function (paymentUrl) {
        if (paymentUrl) {
            $('.payment-proceed-btn').attr('href', paymentUrl);
        } else {
            $('.payment-proceed-btn').addClass('btn-disabled');
        }
    },
    renderCartGroup: function (group) {
        return `
            <div class="cart-wiget__item">
                <div class="text-icon">
                    ${createSvgIconHTML(group.title === 'Сертификаты' ? '/resources/img/icons/certificate-ico.svg' : '/resources/img/icons/ticket-boyer-widget.svg')}
                    <div class="uk-flex uk-flex-between uk-flex-middle uk-width-1-1">
                        <div class="text-17 text-15-sm">
                            ${group.title}
                        </div>
                        <div class="uk-flex uk-flex-bottom gap-8">
                            <div class="h4">
                                ${group.totalPrice}
                            </div>
                            ${group.oldPrice ? `<div class="h5 text-dark-grey text-decoration-line-through">${group.oldPrice}</div>` : ''}
                        </div>
                    </div>
                </div>
                ${group.discounts ? group.discounts.map(discount => `
                        <div class="mt-4 uk-flex uk-flex-between">
                            <div class="text-13">
                                ${discount.title}
                            </div>
                            <div class="text-13">
                                - ${discount.value}
                            </div>
                        </div>`).join('') : ''}
            </div>`
    },
    renderCartDiscount: function (discount) {
        return `
            <div class="uk-flex uk-flex-between uk-flex-middle uk-width-1-1">
                <div class="text-17 text-15-sm">
                    ${discount.title}
                </div>
                <div class="h4">
                    ${discount.value}
                </div>
            </div>`
    },
    renderCartCustom: function (custom) {
        return `
            <div class="text-icon">
                ${createSvgIconHTML('/resources/img/icons/percent-ico.svg')}
                <div class="uk-flex uk-flex-between uk-flex-middle uk-width-1-1">
                    <div class="text-17 text-15-sm">
                        ${custom.title}
                    </div>
                    <div class="h4">
                        ${custom.value}
                    </div>
                </div>
            </div>`
    },
    renderCartTotals: function (cart) {
        const $cartGroupsWrap = $('.cart-groups');
        const $cartDiscountsWrap = $('.cart-discounts');
        const $cartCustomsWrap = $('.cart-customs');
        const $cartSupTotalWrap = $('.totals-entry--total');

        $cartGroupsWrap.empty();
        if (cart.groups?.length) {
            cart.groups.forEach(group => $cartGroupsWrap.append(cartModule.renderCartGroup(group)));
        }

        $cartDiscountsWrap.empty();
        if (cart.discounts?.length) {
            cart.discounts.forEach(discount => $cartDiscountsWrap.append(cartModule.renderCartDiscount(discount)));
        }

        $cartCustomsWrap.empty();
        if (cart.customs?.length) {
            cart.customs.forEach(custom => $cartCustomsWrap.append(cartModule.renderCartCustom(custom)));
        }

        $cartSupTotalWrap.find('.totals-entry__itemprice').text(cart.total);
    },
    cartsListener: function () {
        let itemsForHimself = document.querySelectorAll('.itemForHimself');
        if (itemsForHimself) {
            // TODO It is possible to choose both options at the same time in CART (GIFT)
           // this.clickListener(itemsForHimself, 0);
        }

        let itemsForGift = document.querySelectorAll('.itemForGift');
        if (itemsForGift) {
            // TODO It is possible to choose both options at the same time in CART (GIFT)
          //  this.clickListener(itemsForGift, 1);
        }
    },
    clickListener: function (inputs, isGift) {
        inputs.forEach((element) => {
            element.onclick = (event) => {
                event.preventDefault();
                let lectureId = element.getAttribute('data-lecture-id');
                if (element.checked === false) {
                    this.deleteCartItem(element, lectureId, isGift);
                } else {
                    this.addCartItem(element, lectureId, isGift);
                }
            }
        });
    },
    updateCartItemView: function (element, buyerData) {
        const lecturesWithCount = buyerData.lecturesWithCount[$(element).data('lecture-id')];

        $(element)
          .closest('.cart-item')
          .find('.grid-card__price-link-text__badge')
          .text('за ' + lecturesWithCount.count + ' видео');

        $(element)
            .closest('.cart-item')
            .find('.grid-card__price-link-text__old-price')
            .text(lecturesWithCount.priceOld + " ₽");

        $(element)
          .closest('.cart-item')
          .find('.grid-card__price-link-text__new-price')
          .text(lecturesWithCount.price + " ₽");
    },
    deleteCartItem: function (element, lectureId, isGift) {
        $.ajax({
                url: 'cart/delete-item',
                type: 'post',
                data: {
                    isGift: isGift,
                    lectureId: lectureId,
                }
            }
        ).done((data) => {
                if (data.success === true) {
                    element.checked = !element.checked;
                    element.parentNode.classList.toggle('checked-label');
                    this.recalculateTotalData(data.buyerData);
                    this.updateCartItemView(element, data.buyerData);
                }
            }
        );
    },
    addCartItem: function addCartItem(element, lectureId, isGift) {
        $.ajax({
                url: 'cart/add-item',
                type: 'post',
                data: {
                    isGift: isGift,
                    lectureId: lectureId,
                }
            }
        ).done((data) => {
                if (data.success === true) {
                    element.checked = !element.checked;
                    element.parentNode.classList.toggle('checked-label');
                    this.recalculateTotalData(data.buyerData);
                    this.updateCartItemView(element, data.buyerData);
                }
            }
        );
    },

    recalculatePriceMatrixCart: function () {
        if (cartModule.promoCodeClickHandlerAttached) {
            return;
        }

        cartModule.promoCodeClickHandlerAttached = true;
        document.addEventListener('click', (e) => {
            const applyButton = e.target.closest('.cart_use_promo_code_btn');

            if (applyButton) {
                cartModule.applyPromoCode(applyButton);
                return;
            }

            const removeButton = e.target.closest('.cart_cancel_promo_code_btn');

            if (removeButton) {
                cartModule.removePromoCode(removeButton);
            }
        });
    },
    applyPromoCode: async function (button) {
        const promoCodeInputs = document.querySelectorAll('.promoCode-input');
        const promoCode = promoCodeInputs[0]?.value ?? '';

        if (promoCode === '' || button.classList.contains('btn-loading')) {
            return;
        }

        const couponIcons = document.querySelectorAll('.coupon-svg');

        app.buttonStartLoading(button);
        couponIcons.forEach(icon => icon.style.setProperty('display', 'none', 'important'));

        try {
            const data = await cartModule.postPromoCode('/cart/validate-promo-code/', promoCode);
            const promoCodeObj = data?.promoCode;

            if (!promoCodeObj) {
                return;
            }

            if (promoCodeObj.valid === true) {
                document.querySelectorAll('.promoCode-input-hidden').forEach(input => input.value = promoCode);
                cartModule.showPromoCodeError(null);

                document.querySelectorAll('.use-promo').forEach(el => el.style.display = 'none');
                document.querySelectorAll('.delete-promo').forEach(el => el.style.display = 'inline-flex');
                promoCodeInputs.forEach(input => input.disabled = true);

                cartModule.applyPromoCodeBuyerData(data.buyerData);
            } else if (promoCodeObj.valid === false) {
                cartModule.showPromoCodeError(promoCodeObj.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            app.buttonStopLoading(button);
            couponIcons.forEach(icon => icon.style.removeProperty('display'));
        }
    },
    removePromoCode: async function (button) {
        if (button.classList.contains('btn-loading')) {
            return;
        }

        const promoCodeInputs = document.querySelectorAll('.promoCode-input');
        const promoCode = promoCodeInputs[0]?.value ?? '';

        app.buttonStartLoading(button);

        try {
            const data = await cartModule.postPromoCode('/cart/delete-promo-code/', promoCode);

            if (data?.status !== 'success') {
                cartModule.showPromoCodeError(data?.message ?? null);
                return;
            }

            cartModule.showPromoCodeError(null);
            cartModule.applyPromoCodeBuyerData(data.buyerData);

            promoCodeInputs.forEach(input => {
                input.value = '';
                input.disabled = false;
            });
            document.querySelectorAll('.promoCode-input-hidden').forEach(input => input.value = '');
            document.querySelectorAll('.use-promo').forEach(el => el.style.display = '');
            document.querySelectorAll('.delete-promo').forEach(el => el.style.display = 'none');
        } catch (error) {
            console.error(error);
        } finally {
            app.buttonStopLoading(button);
        }
    },
    postPromoCode: async function (url, promoCode) {
        const response = await fetch(url, {
            method: 'POST',
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            body: new URLSearchParams({promoCode}),
        });

        if (!response.ok) {
            return null;
        }

        return response.json();
    },
    applyPromoCodeBuyerData: function (buyerData) {
        const cart = buyerData.buyerData;

        cartModule.updatePaymentUrl(cart.paymentUrl || false);
        cartModule.updateHeaderCart(cart.count);
        cartModule.renderCartTotals(cart);

        const translationItems = buyerData?.cartItems?.translation;

        if (translationItems) {
            document.querySelectorAll('.cart-group-translation-wrapper').forEach(wrapper => {
                wrapper.replaceChildren();
                translationItems.forEach(item => wrapper.insertAdjacentHTML('beforeend', item));
            });
        }
    },
    showPromoCodeError: function (message) {
        const responseMessage = document.querySelector('.promocode-response-message');

        if (!responseMessage) {
            return;
        }

        if (!message) {
            responseMessage.classList.remove('promocode-response-message--error');
            responseMessage.replaceChildren();
            return;
        }

        const warning = document.createElement('div');
        warning.className = 'payment-option-warning';

        const error = document.createElement('span');
        error.className = 'error';
        error.textContent = message;

        warning.append(error);
        responseMessage.classList.add('promocode-response-message--error');
        responseMessage.replaceChildren(warning);
    },
    recalculateTotalData: function recalculateTotalData(buyerData) {
        let buyerDataSpan = document.querySelector('#buyerData');
        buyerDataSpan.setAttribute('data-buyerData', JSON.stringify(buyerData));
        this.init();
    },
}

$("document").ready(function () {
    cartModule.init();
});
